<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">{{ $route.name }}</div>
      <div class="right" v-if="PERMISIONS.create">
        <div class="right" style="margin-top: 1.2rem">
          <div @click="createItem" class="Button1">
            <div class="icon">
              <img
                @load="imgLoaded"
                src="../assets/media/for_table/circle_ADD_new_etap.svg"
                alt=""
              />
            </div>
            <span class="Btn_content">
              Adaugă ordonator de credite
            </span>
          </div>
        </div>
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          :apiModuleName="'CREDIT_ORDERER_TYPE'"
          :tableMinimizeHead="true"
          :tableSpread="true"
          @Btn2="editItem"
          @Btn3="deleteItem"
          @totalRecords="(x) => (totalRecords = x)"
        />
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "@/mixins/creditOrdererTypePermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { CREDIT_ORDERER_TYPE } from "../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";

export default {
  name: "InstitutionObjectives",
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  data() {
    return {
      tableHead: [
        {
          title: "Nume",
          queryKey: "name",
          bottomHead: {
            quikFiltre: true,
          },
        },

        {
          title: "Creditor principal",
          queryKey: "parent",
          bottomHead: {
            quikFiltre: true,
          },
        },
      ],
      tableModule: CREDIT_ORDERER_TYPE.get,
      totalRecords: 0,
      reloadTable: 0,
    };
  },
  methods: {
    reload() {
      this.reloadTable++;
    },

    initHeadTable() {
      const permMap = {
        instName: ["superadmin"],
      };

      const role = this.getUserRole();

      Object.entries(permMap).forEach((e) => {
        const findHead = this.tableHead.find((head) => head.meta == e[0]);
        if (findHead && e[1].includes(role)) {
          findHead.show = true;
        }
      });
    },
    checkTableHeader(meta) {
      const find = this.tableHead.find((e) => e.meta == meta);
      if (find?.show !== false) {
        return true;
      }
      return false;
    },

    prepareData(row) {
      const preparation = [];
      preparation.push(row.name || "-");
      preparation.push(row.parent ? "DA" : "NU");

      const x = this.PERMISIONS;

      const prepareBtn = [];

      if (x.edit === true) {
        prepareBtn.push(2);
      }
      if (x.delete === true) {
        prepareBtn.push(3);
      }

      if (prepareBtn.length) {
        preparation.push([prepareBtn]);
      }

      return preparation;
    },
    createItem() {
      this.$modal.show(
        DialogModal,
        {
          target: "AddCreditOrdererType",
          title: "Adaugă ",
          inputs: [
            {
              label: "Nume",
              id: "name",
              errReason: "Introduceți numele ordonatorului de credite",
            },
            {
              type: "checkbox",
              name: "Este creditor principal?",
              id: "parent",
              checker: () => true,
            },
          ],
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Adaugă",
            handler: (sendData) => {
              const error = (msg) => {
                this.$toastr.e(
                  msg || "Adăugarea ordonatorului de credite a eșuat."
                );
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              CREDIT_ORDERER_TYPE.add(sendData)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Ordonatorul de credite a fost adăugat.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "AddCreditOrdererType",
          adaptive: true,
          width: "550",
          height: "450",
        }
      );
    },
    editItem(data) {
      if (!Number.isInteger(data.id)) return;

      this.$modal.show(
        DialogModal,
        {
          target: "EditCreditOrdererType",
          title: "Modifică ordonatorul de credite",
          inputs: [
            {
              label: "Nume",
              id: "name",
              errReason: "Introduceți numele ordonatorului de credite.",
            },
            {
              type: "checkbox",
              name: "Este creditor principal?",
              id: "parent",
              checker: () => true,
            },
          ],
          initialInputsData: data,
          closeBtnText: "Anulează",

          button: {
            type: 2,
            value: "Modifică",
            handler: (sendData) => {
              const error = (msg) => {
                this.$toastr.e(
                  msg || "Adăugarea ordonatorului de credite a eșuat."
                );
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              CREDIT_ORDERER_TYPE.edit(data.id, sendData)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s(
                      "Datele ordonatorului de credite au fost modificate."
                    );
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "EditCreditOrdererType",
          adaptive: true,
          width: "550",
          height: "450",
        }
      );
    },

    deleteItem(data) {
      if (!Number.isInteger(data?.id)) return;

      this.$modal.show(
        DialogModal,
        {
          target: "DeleteCreditOrdererType",
          title: "Șterge ordonatorul de credite",
          content:
            '<span style="color:#f44336;display: block;margin-top: 2rem;"><i class="fas fa-exclamation-circle" style="font-size: 6rem;"></i> <p style="font-weight: 500;font-size: 2.2rem;">Ești sigur că vrei să ștergi ordonatorul de credite?</p></span>',
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(
                  msg || "Ștergerea ordonatorului de credite a eșuat."
                );
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              CREDIT_ORDERER_TYPE.delete(data.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Ordonatorul de credite a fost șters.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeleteCreditOrdererType",
          adaptive: true,
          width: "550",
          height: "400",
        }
      );
    },
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    const canViewButtonsColumn = ["edit", "delete"];
    this.initHeadTable();
    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }
  },
};
</script>
